// extracted by mini-css-extract-plugin
module.exports = {"root":"CommFooter_root__tvvJU"};